export default class DropdownViewModel {
    public id: string | number = '';
    public label: string | number = '';
}